<template>
  <custom-separator :text="text" class="custom-separator-extended py-3" />
</template>

<script>
import CustomSeparator from 'custom-separator';
export default {
  name: 'SeparatorExtended',
  components: {
    CustomSeparator,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.custom-separator-extended ::v-deep {
  .separator-custom {
    &:before {
      border-bottom: 1px solid #e2e2e2 !important;
      margin-right: 4px;
      margin-left: 8px;
    }
    &:after {
      border-bottom: 1px solid #e2e2e2 !important;
      margin-left: 4px;
      margin-right: 9px;
    }
    span {
      background: unset !important;
      color: #727272;
      padding: unset !important;
      font-size: 14px;
    }
  }
}
</style>
